// extracted by mini-css-extract-plugin
module.exports = {"button":"_1yKPWs","avatar":"y8HlBP"};